export default function BreakInEngine() {
return (
    <div style={{ maxWidth: 800, margin: '0 auto', lineHeight: 1.7 }}>
        <p>
            Congratulations on choosing Rolling Thunder Cycles Inc. as your engine
            rebuilding and full service shop. Our staff and technicians have many
            years of experience in all aspects of service work, and firmly believe
            that with the high quality standards we have set, our customers are
            getting the finest repairs available today. It is with this in mind,
            that we offer our suggestions for proper break-in and maintenance of
            those parts that were recently repaired at our service facility.
        </p>

        <ol>
            <li>
                <strong>Use high quality engine oil:</strong> Remember these are
                air-cooled engines and operate at a much higher temperature than cars.
                Don't use car oil in your motorcycle. The brand of motorcycle oil we
                recommend for break-in is <strong>"Spectro"</strong>. It is formulated
                specifically for Harley-Davidson air-cooled motorcycles. For proper
                engine break-in, on Evolution 80 cubic inch engines and Twin Cams, use
                a multi-weight oil (20w50), on older models use straight weight oil.
                What the 20w50 weight rating means is the oil is guaranteed, by the
                manufacturer, to be a 20 weight oil at 0°F, and a 50 weight oil at
                200°F. During summer operation heavier weight oil can be used. After
                break-in call for our recommendation on full synthetic oils to help
                extend engine life.
            </li>
            <li>
                <strong>Initial Engine Start-up:</strong> S &amp; S Cycle recommends the following:
                <ol type="a">
                    <li>
                        On initial engine start-up, run the engine approximately one minute at 1250-1750 rpm. <strong>DO NOT</strong> crack the throttle or subject the engine to any loads during this period. The head gaskets are susceptible to failure at this time.
                    </li>
                    <li>
                        Check to see that oil pressure is normal and returning to the tank and there are no oil leaks. Turn off the engine and let cool to the touch.
                    </li>
                    <li>
                        After the engine has cooled, start up again and run engine no longer than 3-4 minutes. When the cylinders become warm to the touch (about 150°F) shut the motor down and let it cool to room temperature.
                    </li>
                    <li>
                        Repeat this procedure 3 to 4 times, each time raising the running temperature 10°F and gently vary the rpm from idle to 2500 in the final cycle.
                    </li>
                    <li>
                        The first 50 miles are the most critical for new rings and piston break-in, most engine damage will initially occur during this period. Keep the heat down by not exceeding 3000 rpm, and vary the speed. Avoid lugging the motor, riding in hot weather or in traffic. Lugging or running engine prematurely at sustained high rpm may result in damage to pistons and other engine components and will void your warranty. If you feel the engine is running hot, pull over to let it cool down. Sometimes, just the trip back home is enough to overheat the engine.
                    </li>
                    <li>
                        The next 500 miles should be spent running the engine no faster than 3500 rpm or the 55-65 mph range. Do not lug the engine, and continue to vary the speed.
                    </li>
                    <li>
                        Up to 1000 miles the speed can be run up to 75 mph, continue to run the engine at all different speeds including the lower 45-55 mph range. Good common sense with a realization of what is really happening inside your engine is the best way to approach proper break-in.
                    </li>
                </ol>
            </li>
            <li>
                <strong>Oil Changes and Filters:</strong> As a new engine breaks in, it is common to find some metallic particles circulating through the engine oil. Changing the oil at regular intervals and the use of a good oil filter is always recommended.
                <ul>
                    <li>
                        On Pre 1984 engines we suggest that the engine oil be changed before initial start up, again at 500 mile and 1,000-mile marks and every thousand miles thereafter.
                    </li>
                    <li>
                        For Evolution and Twin-Cam engines we recommend that the engine oil be changed before initial start up, at 1000 miles and every 2500 miles thereafter.
                    </li>
                    <li>
                        Please call us on recommendations of Full Synthetic oils and proper use in your model motorcycle.
                    </li>
                    <li>
                        It is also a good practice to replace the oil filter at every oil change. Also be sure to clean the oil tank, oil cooler and flush or replace oil lines before starting engine.
                    </li>
                </ul>
            </li>
            <li>
                <strong>Free Overall Tighten Up:</strong> All top end or engine rebuilding work done by Rolling Thunder Cycles is backed by a free overall tighten up. This involves an engine oil and oil filter change (on rebuilt engines), re-tightening of recently assembled parts, and on older models, cylinder head bolts, cylinder base nuts and checking and adjustment of carburetor, pushrods and timing (as applicable). There is no labor charge for this follow-up procedure.
                <ul>
                    <li>
                        As the new engine is run, some gaskets may compress due to heat, and the torque on engine hardware can drop. To prevent gasket failure, we ask our customers to return after approximately 250 miles for a preventative service. By calling a day in advance, most "tighten-ups" can be done while you wait.
                    </li>
                    <li>
                        <strong>NOTE:</strong> Evolution and Twin-Cam engines do not require any re-torque of engine components. If you are assembling rebuilt parts yourself, please refer to your service manual for proper torque values or call your local Rolling Thunder Cycles experts.
                    </li>
                </ul>
            </li>
        </ol>

        <p>
            The above suggestions sound good and normally work, but there is no sure-fire way to insure proper break-in. The uses of good assembly habits and common sense, with an understanding of what is happening are your best tools for proper break-in.
        </p>
        <p>
            Ride safely and call us if you have any questions.
        </p>
    </div>
);
}
